"use client"
import { Container, classNames, FlexCenter } from "@opensea/ui-kit"
import { bottomFixedVariants } from "@/styles/utils/bottom-fixed"

type Props = {
  className?: string
  children: React.ReactNode
}

export function ItemSelectionActionBar({ children, className }: Props) {
  return (
    // So it takes up space
    <div className="h-bottom-action-bar">
      <FlexCenter
        className={classNames(
          "right-scroll-bar-size left-0 z-action-bar h-bottom-action-bar w-full border-border-1 border-t bg-bg-primary",
          "overflow-y-auto",
          "lg:left-side-nav lg:w-[calc(100%_-_theme(spacing.side-nav)-theme(spacing.scroll-bar-size))]",
          bottomFixedVariants(),
          className,
        )}
        data-testid="bottom-action-bar"
      >
        <Container className="flex items-center">{children}</Container>
      </FlexCenter>
    </div>
  )
}
